import { generatePath } from 'react-router-dom'
import { GENERATION_V2_PLAYGROUND_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Sparkle } from 'almanac-ui/icons'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuGenerationV2PlaygroundItem = ({ workspaceId, onPress }: Props) => {
  return (
    <NavMenuItem
      icon={Sparkle}
      activeIcon={Sparkle}
      to={generatePath(GENERATION_V2_PLAYGROUND_PATH, { workspaceId })}
      onPress={onPress}
      label="Gen V2 Playground"
    />
  )
}

export { NavMenuGenerationV2PlaygroundItem }
